/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'disabled': {
    width: 150,
    height: 150,
    viewBox: '0 0 150 150',
    data: '<g _fill="#C4FFF9" fill-rule="nonzero"><path pid="0" d="M111.691 37.514l5.353 5.945-78.03 70.259-5.353-5.946z"/><path pid="1" d="M75.5 128C46.505 128 23 104.495 23 75.5S46.505 23 75.5 23 128 46.505 128 75.5 104.495 128 75.5 128zm.5-7c24.853 0 45-20.147 45-45s-20.147-45-45-45-45 20.147-45 45 20.147 45 45 45z"/></g>'
  }
})
